import { InformationKept } from './WithdrawalRequest.types';

export const informationList: InformationKept[] = [
  { title: '소비자의 불만 또는 분쟁처리에 관한 기록', duration: '3년' },
  { title: '신용정보의 수집/처리 및 이용 등에 관한 기록', duration: '3년' },
  { title: '대금결제 및 재화 등의 공급에 관한 기록', duration: '5년' },
  { title: '계약 또는 청약철회 등에 관한 기록', duration: '5년' },
  { title: '표시/광고에 관한 기록', duration: '6개월' },
];
